import { ActionCreator } from 'redux';
import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { toggleCardsSorting } from '../effects/toggleCardsSorting';

export const onToggleCardsSorting: ActionCreator<ThunkAction> = (
    listId: number,
    isSortingEnabled?: boolean
) => {
    const action = (
        dispatch: Dispatch
    ) => {
        return dispatch(toggleCardsSorting(listId, isSortingEnabled));
    };
    return action;
};
